export type Locale = 'fr' | 'en';

export const messages = {
  fr: {
    'brand.tag': 'Faso Kanu, Bamako',
    'sys.status': 'SYS://JUVO-MALI   STATUS: OPERATIONAL',
    'nav.about': 'à propos',
    'nav.courses': 'cours',
    'nav.donate': 'dons',
    'nav.merch': 'boutique',
    'nav.impact': 'impact',
    'nav.geeks': 'geeks',
    'nav.cart': 'panier',
    'nav.login': 'connexion',
    'nav.signup': 'sign_up()',
    'nav.portal': 'mon juvo',
    'nav.admin': 'admin',
    'nav.logout': 'sortir',
    'footer.mission':
      'Circularité santé-tech, compétences et écosystème de santé numérique. Bamako, Mali.',
    'footer.platform': 'plateforme',
    'footer.contact': 'contact',
    'footer.newsletter': 'newsletter',
    'footer.newsletterBody': 'recevoir les dates de cohortes',
    'footer.email': 'contact@juvo.healthgeek.org.ml',
    'footer.location': 'Faso Kanu, Bamako',
    'footer.rights': '© 2026 JUVO — TOUS DROITS RÉSERVÉS',
    'home.kicker': 'health-tech circularity',
    'home.hero': 'La tech inutilisée devient',
    'home.heroHighlight': 'capacité de soins',
    'home.lede':
      'Nous rénovons du matériel, formons les soignant·es, et transformons la contribution vérifiée en accès — depuis Bamako, Mali.',
    'home.ctaCatalog': 'browse_courses --all',
    'home.ctaGeek': 'join_the_geeks --now',
    'home.heroBadge': 'geek://verified',
    'home.heroAlt': 'Équipe de santé et matériel numérique',
    'home.why': 'Pourquoi Juvo',
    'home.whyBody':
      'Un ordinateur donné sans formation reste un objet. Juvo relie matériel, compétences et reconnaissance pour que chaque ressource serve vraiment.',
    'home.pillarsTag': 'what_we_do',
    'home.pillars': 'Quatre piliers, une boucle',
    'home.pillar1': 'Rénovation circulaire',
    'home.pillar2': 'Formation pratique',
    'home.pillar3': 'Système de crédits JVC',
    'home.pillar4': 'Vrais déploiements',
    'home.catalogTag': 'academy',
    'home.catalogTitle': 'Catalogue public des cours',
    'home.seeAll': 'voir_tout()',
    'home.impactTag': 'jvc_ledger',
    'home.impactLabel': 'crédits émis à ce jour',
    'home.impactCta': 'view_impact --full',
    'home.eventsTag': 'upcoming',
    'home.eventsTitle': 'Dates de démarrage des cohortes',
    'home.donateTag': 'give --type',
    'home.donateTitle': 'Donner du matériel ou des fonds',
    'home.donateIntro': '// les dons de matériel alimentent l’essentiel de ce que nous rénovons et déployons',
    'home.merchTag': 'store',
    'home.merchTitle': 'Boutique Juvo',
    'home.merchIntro': '// les recettes financent l’équipement d’atelier et les bourses de cohorte',
    'home.ctaGeekTag': 'become_a_geek()',
    'home.ctaGeekTitle': 'Contribuez du temps, des compétences ou du matériel.\nGagnez des JVC. Accédez à plus.',
    'donate.lead': 'le plus fréquent',
    'donate.techTag': 'donate_tech()',
    'donate.techTitle': 'Donner du matériel',
    'donate.techBody':
      'Ordinateurs, portables, réseau, ou appareils santé/numériques — fonctionnels ou non. Nous évaluons, rénovons, redéployons.',
    'donate.kg': 'kg rénovés',
    'donate.devices': 'appareils ce trimestre',
    'donate.pickup': 'schedule_pickup()',
    'donate.fundsTag': 'donate_funds()',
    'donate.fundsTitle': 'Donner des fonds',
    'donate.fundsBody': 'Couvre les fournitures de rénovation, l’atelier, et les bourses de formation.',
    'donate.raisedToward': 'collectés sur l’objectif trimestriel de',
    'donate.custom': 'autre',
    'donate.now': 'donate_now()',
    'donate.pageTitle': 'Dons',
    'donate.pageIntro':
      'Le matériel est le don le plus utile. Les fonds couvrent ce que le matériel ne paie pas : pièces, transport, bourses.',
    'donate.name': 'Nom',
    'donate.email': 'E-mail',
    'donate.phone': 'Téléphone',
    'donate.city': 'Ville',
    'donate.description': 'Que donnez-vous ?',
    'donate.quantity': 'Quantité',
    'donate.note': 'Note (optionnel)',
    'donate.amount': 'Montant (USD)',
    'donate.techThanks': 'Demande enregistrée. L’équipe vous contacte pour l’enlèvement.',
    'donate.fundsThanks': 'Promesse enregistrée. Merci — le paiement en ligne arrive ensuite.',
    'donate.error': 'Impossible d’envoyer pour le moment. Réessayez.',
    'merch.pageTitle': 'Boutique Juvo',
    'merch.pageIntro': 'Les recettes financent l’équipement d’atelier et les bourses de cohorte.',
    'merch.add': 'add_to_cart()',
    'merch.added': 'Ajouté au panier',
    'merch.cartTitle': 'Panier',
    'merch.empty': 'Panier vide.',
    'merch.checkout': 'checkout()',
    'merch.qty': 'Qté',
    'merch.total': 'Total',
    'merch.city': 'Ville',
    'merch.note': 'Note de commande',
    'merch.thanks': 'Commande enregistrée. Nous vous écrivons pour la livraison / le paiement.',
    'merch.error': 'Commande impossible pour le moment.',
    'merch.browse': 'voir_boutique()',
    'courses.title': 'Catalogue Academy',
    'courses.intro':
      'Formations pratiques à Faso Kanu. Filtrez par parcours, puis inscrivez-vous à une cohorte.',
    'courses.search': 'Rechercher un cours',
    'courses.allTracks': 'Tous les parcours',
    'courses.empty': 'Aucun cours ne correspond.',
    'course.cohorts': 'Cohortes',
    'course.seats': 'places',
    'course.enroll': 'S’inscrire à cette cohorte',
    'course.needAccount': 'Un compte est demandé uniquement pour l’inscription.',
    'course.weeks': 'semaines',
    'auth.loginTitle': 'Connexion',
    'auth.loginBody': 'Mot de passe pour l’équipe. Lien magique pour les apprenant·es.',
    'auth.signupTitle': 'Créer un compte',
    'auth.signupBody': 'Inscrivez-vous pour rejoindre une cohorte. Le catalogue reste public.',
    'auth.email': 'E-mail',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom',
    'auth.submit': 'Continuer',
    'auth.magic': 'Recevoir un lien magique',
    'auth.or': 'ou',
    'impact.title': 'Impact',
    'impact.intro':
      'Année 1 : prouver la boucle complète à petite échelle, pas maximiser le volume.',
    'impact.live': 'Compteurs live',
    'impact.target': 'Cible année 1',
    'impact.kg': 'kg rénovés',
    'impact.cohorts': 'Cohortes',
    'impact.partners': 'Partenaires',
    'impact.deployments': 'Déploiements',
    'impact.jvc': 'JVC émis',
    'geeks.title': 'Communauté Juvo Geek',
    'geeks.body':
      'Les Geeks contribuent du temps, des compétences et du matériel. Les contributions vérifiées génèrent des crédits JVC.',
    'geeks.cta': 'join_the_geeks --now',
    'portal.dashboard': 'Tableau de bord',
    'portal.courses': 'Mes cours',
    'portal.contribute': 'Contribuer',
    'portal.credits': 'Crédits',
    'portal.profile': 'Profil',
    'portal.welcome': 'Bonjour',
    'portal.balance': 'Solde JVC',
    'portal.emptyCourses': 'Aucune inscription pour le moment.',
    'portal.contributeBody':
      'Les contributions (temps, compétence, matériel, service) seront vérifiées par l’équipe avant d’émettre des JVC.',
    'portal.memberBadge': 'Membre Juvo Geek',
    'portal.hub': 'Pôle : Faso Kanu, Bamako',
    'portal.logContribution': 'Déclarer une contribution',
    'portal.statusEnrolled': 'Inscrit',
    'portal.statusWaitlisted': 'Liste d’attente',
    'portal.statusCompleted': 'Terminé',
    'portal.browseCourses': 'Parcourir les cours',
    'about.kicker': 'qui_sommes_nous',
    'about.title': 'Transformer la tech inutilisée en autonomie sanitaire',
    'about.subtitle': 'Juvo est une entreprise sociale d’économie circulaire santé-tech ancrée à Faso Kanu, Bamako (Mali).',
    'about.manifesto': 'La tech inutilisée devient outils de santé, compétences pratiques, opportunité économique et impact social mesurable.',
    'about.pillar1Title': '1. Rénovation Circulaire',
    'about.pillar1Desc': 'Collecte, test rigoureux, reconditionnement et déploiement d’équipements informatiques et biomédicaux vers les CSComs et centres de santé.',
    'about.pillar2Title': '2. Juvo Academy',
    'about.pillar2Desc': 'Formation technique pratique aux métiers du numérique en santé : maintenance, systèmes cliniques, télémédecine et diagnostic.',
    'about.pillar3Title': '3. Crédits Juvo (JVC)',
    'about.pillar3Desc': 'Système de rétribution en boucle fermée valorisant les contributions vérifiées de la communauté : heures de réparation, dons, encadrement.',
    'about.pillar4Title': '4. Plateforme Numérique',
    'about.pillar4Desc': 'Traçabilité intégrale de bout en bout de chaque machine, cohortes d’apprenant·es et transaction de crédits pour une transparence totale.',
    'about.hubTitle': 'L’Atelier-École de Faso Kanu',
    'about.hubDesc': 'Implanté au cœur de Bamako, notre atelier allie bancs de test matériels, salle de formation informatique et espace communautaire de makers.',
    'about.targetsTitle': 'Objectifs de l’Année 1',
    'admin.courses': 'Cours',
    'admin.enrollment': 'Inscriptions',
    'admin.merch': 'Boutique / Merch',
    'admin.metrics': 'Métriques & Impact',
    'admin.assets': 'Actifs',
    'admin.jvc': 'JVC',
    'admin.partners': 'Partenaires',
    'admin.phase2': 'Module prévu à la phase 2 (atelier, ledger, partenaires).',
    'notfound': 'Page introuvable',
    'lang.fr': 'FR',
    'lang.en': 'EN',
  },
  en: {
    'brand.tag': 'Faso Kanu, Bamako',
    'sys.status': 'SYS://JUVO-MALI   STATUS: OPERATIONAL',
    'nav.about': 'about',
    'nav.courses': 'courses',
    'nav.donate': 'donate',
    'nav.merch': 'merch',
    'nav.impact': 'impact',
    'nav.geeks': 'geeks',
    'nav.cart': 'cart',
    'nav.login': 'log in',
    'nav.signup': 'sign_up()',
    'nav.portal': 'my juvo',
    'nav.admin': 'admin',
    'nav.logout': 'log out',
    'footer.mission':
      'Health technology circularity, skills & digital health ecosystem. Bamako, Mali.',
    'footer.platform': 'platform',
    'footer.contact': 'contact',
    'footer.newsletter': 'newsletter',
    'footer.newsletterBody': 'get cohort updates',
    'footer.email': 'contact@juvo.healthgeek.org.ml',
    'footer.location': 'Faso Kanu, Bamako',
    'footer.rights': '© 2026 JUVO — ALL RIGHTS RESERVED',
    'home.kicker': 'health-tech circularity',
    'home.hero': 'Unused tech becomes',
    'home.heroHighlight': 'healthcare',
    'home.lede':
      'We refurbish equipment, train health workers, and turn verified contribution into access — starting in Bamako, Mali.',
    'home.ctaCatalog': 'browse_courses --all',
    'home.ctaGeek': 'join_the_geeks --now',
    'home.heroBadge': 'geek://verified',
    'home.heroAlt': 'Health workers and digital equipment',
    'home.why': 'Why Juvo',
    'home.whyBody':
      'A donated computer without training is still just an object. Juvo connects hardware, skills, and recognition so each resource actually serves.',
    'home.pillarsTag': 'what_we_do',
    'home.pillars': 'Four pillars, one loop',
    'home.pillar1': 'Circular refurbishment',
    'home.pillar2': 'Practical training',
    'home.pillar3': 'JVC credit system',
    'home.pillar4': 'Real deployments',
    'home.catalogTag': 'academy',
    'home.catalogTitle': 'Public course catalog',
    'home.seeAll': 'see_all()',
    'home.impactTag': 'jvc_ledger',
    'home.impactLabel': 'credits issued so far',
    'home.impactCta': 'view_impact --full',
    'home.eventsTag': 'upcoming',
    'home.eventsTitle': 'Cohort start dates',
    'home.donateTag': 'give --type',
    'home.donateTitle': 'Donate tech or funds',
    'home.donateIntro': '// tech donations drive most of what we refurbish and deploy',
    'home.merchTag': 'store',
    'home.merchTitle': 'Juvo merch',
    'home.merchIntro': '// proceeds fund workshop equipment and cohort scholarships',
    'home.ctaGeekTag': 'become_a_geek()',
    'home.ctaGeekTitle': 'Contribute time, skills, or equipment.\nEarn JVC. Access more.',
    'donate.lead': 'most common',
    'donate.techTag': 'donate_tech()',
    'donate.techTitle': 'Give equipment',
    'donate.techBody':
      'Computers, laptops, networking gear, or health/digital devices — working or not. We assess, refurbish, and redeploy.',
    'donate.kg': 'kg refurbished',
    'donate.devices': 'devices this quarter',
    'donate.pickup': 'schedule_pickup()',
    'donate.fundsTag': 'donate_funds()',
    'donate.fundsTitle': 'Give funds',
    'donate.fundsBody': 'Covers refurbishment supplies, workshop costs, and training scholarships.',
    'donate.raisedToward': "raised toward this quarter's",
    'donate.custom': 'custom',
    'donate.now': 'donate_now()',
    'donate.pageTitle': 'Donate',
    'donate.pageIntro':
      'Equipment is the most useful gift. Funds cover what hardware cannot: parts, transport, scholarships.',
    'donate.name': 'Name',
    'donate.email': 'Email',
    'donate.phone': 'Phone',
    'donate.city': 'City',
    'donate.description': 'What are you giving?',
    'donate.quantity': 'Quantity',
    'donate.note': 'Note (optional)',
    'donate.amount': 'Amount (USD)',
    'donate.techThanks': 'Request saved. The team will contact you to schedule pickup.',
    'donate.fundsThanks': 'Pledge saved. Thank you — online payment lands next.',
    'donate.error': 'Could not send right now. Please try again.',
    'merch.pageTitle': 'Juvo merch',
    'merch.pageIntro': 'Proceeds fund workshop equipment and cohort scholarships.',
    'merch.add': 'add_to_cart()',
    'merch.added': 'Added to cart',
    'merch.cartTitle': 'Cart',
    'merch.empty': 'Cart is empty.',
    'merch.checkout': 'checkout()',
    'merch.qty': 'Qty',
    'merch.total': 'Total',
    'merch.city': 'City',
    'merch.note': 'Order note',
    'merch.thanks': 'Order saved. We will write you about delivery / payment.',
    'merch.error': 'Could not place the order right now.',
    'merch.browse': 'browse_store()',
    'courses.title': 'Academy catalog',
    'courses.intro':
      'Practical training at Faso Kanu. Filter by track, then enroll in a cohort.',
    'courses.search': 'Search courses',
    'courses.allTracks': 'All tracks',
    'courses.empty': 'No courses match.',
    'course.cohorts': 'Cohorts',
    'course.seats': 'seats',
    'course.enroll': 'Enroll in this cohort',
    'course.needAccount': 'An account is only required to enroll.',
    'course.weeks': 'weeks',
    'auth.loginTitle': 'Log in',
    'auth.loginBody': 'Password for staff. Magic link for learners.',
    'auth.signupTitle': 'Create an account',
    'auth.signupBody': 'Sign up to join a cohort. The catalog stays public.',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Name',
    'auth.submit': 'Continue',
    'auth.magic': 'Send a magic link',
    'auth.or': 'or',
    'impact.title': 'Impact',
    'impact.intro': 'Year 1 is about proving the full loop at small scale, not maximizing volume.',
    'impact.live': 'Live counters',
    'impact.target': 'Year 1 target',
    'impact.kg': 'kg refurbished',
    'impact.cohorts': 'Cohorts',
    'impact.partners': 'Partners',
    'impact.deployments': 'Deployments',
    'impact.jvc': 'JVC issued',
    'geeks.title': 'Juvo Geek community',
    'geeks.body':
      'Geeks contribute time, skills, and equipment. Verified contributions mint JVC credits.',
    'geeks.cta': 'join_the_geeks --now',
    'portal.dashboard': 'Dashboard',
    'portal.courses': 'My courses',
    'portal.contribute': 'Contribute',
    'portal.credits': 'Credits',
    'portal.profile': 'Profile',
    'portal.welcome': 'Hello',
    'portal.balance': 'JVC balance',
    'portal.emptyCourses': 'No enrollments yet.',
    'portal.contributeBody':
      'Contributions (time, skill, equipment, service) are staff-verified before JVC is issued.',
    'portal.memberBadge': 'Juvo Geek Member',
    'portal.hub': 'Hub: Faso Kanu, Bamako',
    'portal.logContribution': 'Log a contribution',
    'portal.statusEnrolled': 'Enrolled',
    'portal.statusWaitlisted': 'Waitlisted',
    'portal.statusCompleted': 'Completed',
    'portal.browseCourses': 'Browse courses',
    'about.kicker': 'about_us',
    'about.title': 'Turning unused technology into healthcare capability',
    'about.subtitle': 'Juvo is a mission-locked health-tech circularity social enterprise based in Faso Kanu, Bamako (Mali).',
    'about.manifesto': 'Unused technology becomes accessible healthcare tools, practical skills, economic opportunity, and measurable social impact.',
    'about.pillar1Title': '1. Circular Refurbishment',
    'about.pillar1Desc': 'Responsible collection, testing, refurbishment, and deployment of computing and medical tech to local clinics (CSComs).',
    'about.pillar2Title': '2. Juvo Academy',
    'about.pillar2Desc': 'Practical skills development in healthcare digital technology: hardware repair, clinical information systems, and telemedicine.',
    'about.pillar3Title': '3. Juvo Credits (JVC)',
    'about.pillar3Desc': 'Closed-loop contribution recognition rewarding community work: repair hours, peer tutoring, and hardware contributions.',
    'about.pillar4Title': '4. Digital Platform',
    'about.pillar4Desc': 'End-to-end traceability verifying hardware lifecycle (JUV-MAL-...), cohort progress, and verifiable public impact.',
    'about.hubTitle': 'The Faso Kanu Workshop Hub',
    'about.hubDesc': 'Located in Bamako, Mali, our hub combines hardware testing benches, an IT training academy, and an open maker community space.',
    'about.targetsTitle': 'Year 1 Commitments',
    'admin.courses': 'Courses',
    'admin.enrollment': 'Enrollment',
    'admin.merch': 'Store / Merch',
    'admin.metrics': 'Metrics & Impact',
    'admin.assets': 'Assets',
    'admin.jvc': 'JVC',
    'admin.partners': 'Partners',
    'admin.phase2': 'Scheduled for phase 2 (workshop floor, ledger, partners).',
    'notfound': 'Page not found',
    'lang.fr': 'FR',
    'lang.en': 'EN',
  },
} as const;

export type MessageKey = keyof (typeof messages)['fr'];
